import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { EventTaskType, EVENT_TASK_TYPE_MAP } from '@sr/dto/dist/src/enums/events';
import { BaseUrlParamsFilterProps } from 'entities/filters/base-url-params-filter';
import { useSearchParams } from 'react-router-dom';
import { PAGE_FIELD_NAME } from 'shared/hooks/paging-params';

const EVENT_TYPE_ITEMS = Object.values(EventTaskType)
  .filter((type) => type !== EventTaskType.MISSED_CALL)
  .map((type) => ({
    id: type,
    label: EVENT_TASK_TYPE_MAP[type],
  }));

export const EventTypeParamFilter = ({ queryParamName }: BaseUrlParamsFilterProps & { multi?: boolean; customSize?: number }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selected = searchParams.get(queryParamName)?.split(',').filter(Boolean) ?? [];

  const handleChange = (id: EventTaskType, checked: boolean) => {
    const next = checked ? [...selected, id] : selected.filter((value) => value !== id);

    setSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev);
        if (next.length) {
          params.set(queryParamName, Array.from(new Set(next)).join(','));
        } else {
          params.delete(queryParamName);
        }
        params.delete(PAGE_FIELD_NAME);
        return params;
      },
      { replace: true },
    );
  };

  return (
    <FormGroup>
      {EVENT_TYPE_ITEMS.map((item) => (
        <FormControlLabel
          key={item.id}
          control={<Checkbox size="small" checked={selected.includes(item.id)} onChange={(event) => handleChange(item.id, event.target.checked)} />}
          label={item.label}
        />
      ))}
    </FormGroup>
  );
};
